import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-917c4d0e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"background-color":"#1f201f","height":"100%"} }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "footer" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_loading = _resolveComponent("van-loading")!
  const _component_van_image = _resolveComponent("van-image")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_van_image, {
        src: _ctx.content,
        width: "303",
        height: "400"
      }, {
        loading: _withCtx(() => [
          _createVNode(_component_van_loading, {
            type: "spinner",
            size: "20"
          })
        ]),
        _: 1
      }, 8, ["src"])
    ]),
    _hoisted_3
  ]))
}